//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - Start

import { ALERTS } from '../actionTypes';
const initialState = {
    arrAlerts: [],
    trigerredAlerts: [],
    setAlerResp: {},
    objModifyAlertResp: {},
    objDeleteAlertResp: {},
    strSearchAlertBySymbol: '',
    objFilterAlertFromModal: {}, // Vinit R - 24-04-2024 BT-107432 Breeze - Alerts 
    strActiveAlertTab: '',
    nTriggerAlertCountFromRedux: null

};

const alertsReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case ALERTS.GET_ALERTS_SUCCESS: {
            return {
                ...state,
                arrAlerts: actions.payload
            };


        }

        case ALERTS.GET_ALERTS_FAILURE:
            return {
                ...state,
                arrAlerts: actions.payload
            };
        case ALERTS.SET_ALERTS_SUCCESS:
            return {
                ...state,
                setAlerResp: actions.payload
            };
        case ALERTS.SET_ALERTS_FAILURE:
            return {
                ...state,
                setAlerResp: actions.payload
            };
        case ALERTS.GET_ALERT_TRIGGED_SUCCESS:
            return {
                ...state,
                trigerredAlerts: actions.payload
            };
        case ALERTS.GET_ALERT_TRIGGED_FAILURE:
            return {
                ...state,
                trigerredAlerts: actions.payload
            };

        case ALERTS.MODIFY_ALERT_RESPONCE:
            return {
                ...state,
                objModifyAlertResp: actions.payload
            };
        case ALERTS.DELETE_ALERT_RESPONCE:
            return {
                ...state,
                objDeleteAlertResp: actions.payload
            };
        case ALERTS.SEARCH_ALERT_BY_SYMBOL:
            return {
                ...state,
                strSearchAlertBySymbol: actions.payload
            };
        case ALERTS.SEARCH_ALERT_BY_DROPDOWN:
            return {
                ...state,
                objFilterAlertFromModal: actions.payload
            };
        case ALERTS.SET_ACTIVE_ALERT_TAB_BY_DEFAULT:
            return {
                ...state,
                strActiveAlertTab: actions.payload
            };
        case ALERTS.SET_TRIGGER_ALERT_COUNT:
            return {
                ...state,
                nTriggerAlertCountFromRedux: actions.payload
            };

        default:
            return state;
    }

};

export default alertsReducer;
//AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - End
